import {
	getIssueRemoteDataQuery,
	ISSUE_VIEW_REMOTE_DATA_QUERY,
} from '@atlassian/jira-issue-fetch-services-common/src/services/issue-view-remote-data/index.tsx';
import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';
import { getClient } from '../../common/utils/client.tsx';
import type { RemoteDataGraphQlResponse } from './types.tsx';

export const fetchIssueViewRemoteData = async (issueKey: IssueKey) => {
	const variables = {
		issueKey,
	};

	const payload = {
		query: getIssueRemoteDataQuery(),
		variables,
		operationName: ISSUE_VIEW_REMOTE_DATA_QUERY,
	};

	const response = await getClient().query<RemoteDataGraphQlResponse>(payload);
	return response;
};
